import CelebrateIcon from '@gik/stream/assets/reactions/buttons/celebrate.svg';
import HahaIcon from '@gik/stream/assets/reactions/buttons/haha.svg';
import HeartIcon from '@gik/stream/assets/reactions/buttons/heart.svg';
import AngryIcon from '@gik/stream/assets/reactions/buttons/mad.svg';
import PrayersIcon from '@gik/stream/assets/reactions/buttons/prayers.svg';
import SadIcon from '@gik/stream/assets/reactions/buttons/sad.svg';
import SickIcon from '@gik/stream/assets/reactions/buttons/sick.svg';
import StrongIcon from '@gik/stream/assets/reactions/buttons/strong.svg';
import ThumbsDown from '@gik/stream/assets/reactions/buttons/thumb-down.svg';
import ThumbsUp from '@gik/stream/assets/reactions/buttons/thumb-up.svg';
import CelebrateIconMini from '@gik/stream/assets/reactions/mini/celebrate.svg';
import HahaIconMini from '@gik/stream/assets/reactions/mini/haha.svg';
import HeartIconMini from '@gik/stream/assets/reactions/mini/heart.svg';
import AngryIconMini from '@gik/stream/assets/reactions/mini/mad.svg';
import PrayersIconMini from '@gik/stream/assets/reactions/mini/prayers.svg';
import SadIconMini from '@gik/stream/assets/reactions/mini/sad.svg';
import SickIconMini from '@gik/stream/assets/reactions/mini/sick.svg';
import StrongIconMini from '@gik/stream/assets/reactions/mini/strong.svg';
import ThumbsDownMini from '@gik/stream/assets/reactions/mini/thumb-down.svg';
import ThumbsUpMini from '@gik/stream/assets/reactions/mini/thumb-up.svg';
import type { ReactionEmojiKey } from '@gik/ui/OpenMoji';
import { SvgIcon } from '@gik/ui/SvgIcon';
import React from 'react';
import { ReactionTypes } from '../types/reactions';

export function renderReactionIcon(name: ReactionEmojiKey, mini?: boolean) {
  switch (name) {
    case ReactionTypes.Love:
      return <SvgIcon Icon={mini ? HeartIconMini : HeartIcon} name={name} />;
    case ReactionTypes.Like:
      return <SvgIcon Icon={mini ? ThumbsUpMini : ThumbsUp} name={name} />;
    case ReactionTypes.Dislike:
      return <SvgIcon Icon={mini ? ThumbsDownMini : ThumbsDown} name={name} />;
    case ReactionTypes.Haha:
      return <SvgIcon Icon={mini ? HahaIconMini : HahaIcon} name={name} />;
    case ReactionTypes.Strong:
      return <SvgIcon Icon={mini ? StrongIconMini : StrongIcon} name={name} />;
    case ReactionTypes.Prayers:
      return <SvgIcon Icon={mini ? PrayersIconMini : PrayersIcon} name={name} />;
    case ReactionTypes.Sad:
      return <SvgIcon Icon={mini ? SadIconMini : SadIcon} name={name} />;
    case ReactionTypes.Angry:
      return <SvgIcon Icon={mini ? AngryIconMini : AngryIcon} name={name} />;
    case ReactionTypes.Celebrate:
      return <SvgIcon Icon={mini ? CelebrateIconMini : CelebrateIcon} name={name} />;
    case ReactionTypes.Sick:
      return <SvgIcon Icon={mini ? SickIconMini : SickIcon} name={name} />;
    default:
      return <SvgIcon Icon={mini ? HeartIconMini : HeartIcon} name={name} />;
  }
}

export function renderReactionLabel(name: ReactionEmojiKey) {
  switch (name) {
    case ReactionTypes.Love:
      return 'Love';
    case ReactionTypes.Like:
      return 'Like';
    case ReactionTypes.Dislike:
      return 'Dislike';
    case ReactionTypes.Haha:
      return 'Haha';
    case ReactionTypes.Strong:
      return 'Strong';
    case ReactionTypes.Prayers:
      return 'Prayers';
    case ReactionTypes.Sad:
      return 'Sad';
    case ReactionTypes.Angry:
      return 'Angry';
    case ReactionTypes.Celebrate:
      return 'Celebrate';
    case ReactionTypes.Sick:
      return 'Sick';
    default:
      return 'React';
  }
}
